import { sha256 } from 'js-sha256'
import CryptoJS from 'crypto-js'

const secretKey: string = '18ab56cd7e981cda'

/**
 * 验证用户令牌
 * @param userInfo 用户信息字符串
 * @param userHash 用户哈希值
 * @returns 验证是否通过
 */
export const judge_token = (userInfo: string | null, userHash: string | null): boolean => {
	if (userInfo && userHash) {
		return sha256(userInfo) === userHash
	}
	return false
}

/**
 * ECB模式AES加密
 * @param data 要加密的数据
 * @returns 加密后的字符串
 */
export const getAesStringECB = (data: string): string => {
	// 加密
	const keys = CryptoJS.enc.Utf8.parse(secretKey)
	const encrypt = CryptoJS.AES.encrypt(data, keys, {
		mode: CryptoJS.mode.ECB, // 使用 ECB 模式
		padding: CryptoJS.pad.Pkcs7 // padding 处理
	})
	return encrypt.toString() // 加密完成后，转换成字符串
}

/**
 * ECB模式AES解密
 * @param encrypted 加密的字符串
 * @returns 解密后的字符串
 */
export const getDAesStringECB = (encrypted: string): string => {
	// 解密
	const keys = CryptoJS.enc.Utf8.parse(secretKey)
	const decrypted = CryptoJS.AES.decrypt(encrypted, keys, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	})
	return decrypted.toString(CryptoJS.enc.Utf8)
}
